/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/require-default-props */

import React from "react";
import { Route, Routes as ReactDOMRoutes } from "react-router-dom";

/** Pages */
import Login from "@pages/Login";
import SignUp from "src/pages/SignUp";
import ForgotPassword from "@pages/ForgotPassword";
import ResendEmailConfirmation from "@pages/ResendEmailConfirmation";
import Contract from "@pages/Contract";
import Concreting from "@pages/Concreting";
import Invoice from "@pages/Invoice";
import Certificate from "@pages/Certificate";
import Dashboard from "@pages/Dashboard";
import Client from "@pages/Client";
import Permission from "@pages/Permission";
import PermissionUser from "@pages/PermissionUser";
import ConcretingRequests from "@pages/ConcretingRequests";
import ConcretingRequest from "@pages/ConcretingRequest";
import ConcretingApprovals from "src/pages/ConcretingApproval";
import Settings from "src/pages/Settings";
import Docs from "@pages/Docs";

// libraries
import { atom } from "@libraries/jotai";

import TravelSharing from "@pages/TravelSharing";
import PrivateRoute from "./PrivateRoute";

const Routes: React.FC = () => (
  <ReactDOMRoutes>
    <Route path="login" element={<Login />} />
    <Route path="sign-up" element={<SignUp />} />
    <Route path="forgot-password" element={<ForgotPassword />} />
    <Route path="resend-email-confirmation" element={<ResendEmailConfirmation />} />
    <Route path="travel-sharing" element={<TravelSharing />} />

    <Route path="" element={<PrivateRoute component={<Dashboard />} />} />
    <Route
      path="contracts"
      element={<PrivateRoute component={<Contract />} />}
    />
    <Route
      path="concretings"
      element={<PrivateRoute component={<Concreting />} />}
    />
    <Route path="invoices" element={<PrivateRoute component={<Invoice />} />} />
    <Route
      path="certificates"
      element={<PrivateRoute component={<Certificate />} />}
    />
    <Route path="clients" element={<PrivateRoute component={<Client />} />} />
    <Route
      path="concreting-requests"
      element={<PrivateRoute component={<ConcretingRequests />} />}
    />
    <Route
      path="concreting-approvals"
      element={<PrivateRoute component={<ConcretingApprovals />} onlyAdmin />}
    />
    <Route
      path="concreting-request"
      element={
        <PrivateRoute
          component={
            <ConcretingRequest selectedStepTabAtom={atom<number>(0)} />
          }
        />
      }
    />
    <Route
      path="permissions"
      element={<PrivateRoute component={<Permission />} onlyAdmin />}
    />
    <Route
      path="permission-user"
      element={<PrivateRoute component={<PermissionUser />} onlyAdmin />}
    />
    <Route
      path="settings"
      element={<PrivateRoute component={<Settings />} />}
    />
    <Route path="docs" element={<PrivateRoute component={<Docs />} />} />
  </ReactDOMRoutes>
);

export default Routes;
